import { defineMessages } from 'react-intl'

export default defineMessages({
  textAccountInfo: {
    id: 'AccountInfo.text.account_info',
    defaultMessage: 'Your account is managed by Husqvarna Group, changes could apply to multiple Husqvarna Group services. All rights reserved.'
  },
});
